import { Button } from 'reactstrap';
import React from 'react';
import PropTypes from 'prop-types';
import Icon from './containers/icon';
const DownloadButton = _ref => {
  let _ref$url = _ref.url,
    url = _ref$url === void 0 ? '' : _ref$url,
    _ref$documentTitle = _ref.documentTitle,
    documentTitle = _ref$documentTitle === void 0 ? '' : _ref$documentTitle,
    _ref$buttonText = _ref.buttonText,
    buttonText = _ref$buttonText === void 0 ? '' : _ref$buttonText;
  const msg = buttonText.length ? buttonText : 'Download';
  const button = /*#__PURE__*/React.createElement(Button, {
    download: true,
    href: url
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "download"
  }), " ", msg);
  const hasTitle = documentTitle && documentTitle.length;
  const hasURL = url === null || url === void 0 ? void 0 : url.length;
  const alert = "\n    Your browser is not compatible with this PDF viewer. Please try Google\n    Chrome".concat(hasURL ? ', or click the Download button below to download the PDF' : '', ".\n  ");
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", null, "Could not display ", hasTitle ? "\"".concat(documentTitle, "\"") : 'the file', "."), /*#__PURE__*/React.createElement("p", null, alert), hasURL ? button : null);
};
DownloadButton.propTypes = {
  url: PropTypes.string,
  documentTitle: PropTypes.string,
  buttonText: PropTypes.string
};
export default DownloadButton;